import React from "react";
import "./style.scss";
import Rating from "@mui/material/Rating";
import OptionScaleButton from "../OptionScaleButton";
import { convertNumberToArray } from "../../Utils/common";
import EmojiRating from "./emojiRating";


interface CustomRatingProps {
  ratingValue: any;
  previewType?: string
}


const CustomRating: React.FC<CustomRatingProps> = ({ ratingValue, previewType }) => {
  const [selectedOption, setSelectedOption] = React.useState<number | null>(null);


  return (
    <div className="rating-container">
      <div className="rating-inner-container">
        {ratingValue?.ratingSettings?.isStar ? (
          <>
            <Rating
              name="customized-10"
              color="red"
              max={ratingValue?.ratingSettings?.max || 5}
            />
          </>
        ) : ratingValue?.ratingSettings?.isStyledRating ? (
          <EmojiRating
            ratingValue={ratingValue}
          />
        )
          : (
            <>
              <div className="option-scale-container">
                {previewType && ['tab', 'mobile'].includes(previewType) && (
                  <div className="label-container">
                    {ratingValue?.ratingSettings?.label?.start && (
                      <div className="Label">
                        {ratingValue?.ratingSettings?.min} {" => "}
                        <span className="TextWrapper">
                          {ratingValue?.ratingSettings?.label?.start}
                        </span>
                      </div>
                    )}
                    {ratingValue?.ratingSettings?.label?.mid && (
                      <div className="Label">
                        {ratingValue?.ratingSettings?.max && Math.ceil(ratingValue?.ratingSettings?.max / 2)} {" => "}
                        <span className="TextWrapper">
                          {ratingValue?.ratingSettings?.label?.mid}
                        </span>
                      </div>
                    )}
                    {ratingValue?.ratingSettings?.label?.mid && (
                      <div className="Label">
                        {ratingValue?.ratingSettings?.max} {" => "}
                        <span className="TextWrapper">
                          {ratingValue?.ratingSettings?.label?.end}
                        </span>
                      </div>
                    )}
                  </div>
                )}
                <div className="option-buttons">
                  {convertNumberToArray(
                    ratingValue?.ratingSettings?.min,
                    ratingValue?.ratingSettings?.max
                  )?.map((label: number | string, ind: number) => {
                    const newIndex =
                      ratingValue?.ratingSettings?.min === 0 ? ind : ind + 1;
                    return (
                      <OptionScaleButton
                        text={label}
                        isSelected={newIndex === selectedOption}
                        handleClick={(val) => setSelectedOption(ratingValue?.ratingSettings?.min === 0 ? val : val + 1)}
                        index={ind}
                      />
                    );
                  })}
                </div>
                {previewType && !['tab', 'mobile'].includes(previewType) && (
                  <div className="bottom-label-container">
                    <div className="Labels">
                      <div className="Label start">
                        <span className="TextWrapper ">
                          {ratingValue?.ratingSettings?.label?.start}
                        </span>
                      </div>
                      <div className="Label center">
                        <span className="TextWrapper ">
                          {ratingValue?.ratingSettings?.label?.mid}
                        </span>
                      </div>
                      <div className="Label end">
                        <span className="TextWrapper ">
                          {ratingValue?.ratingSettings?.label?.end}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
      </div>
    </div>
  );
};

export default CustomRating;
